import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef } from 'react';
import { StyleSheet, styled, text, border, padding, margin } from '@rexlabs/styling';
import ActionMenu from '@rexlabs/action-menu';
var defaultStyles = StyleSheet({
  container: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    boxSizing: 'border-box',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    flex: '0 0 auto',
    flexDirection: 'row',
    alignItems: 'center',
    transition: 'color ease-out 150ms, background ease-out 150ms',
    textTransform: function textTransform(_ref) {
      var token = _ref.token;
      return token('tabs.tab.textTransform', 'none');
    },
    height: function height(_ref2) {
      var token = _ref2.token;
      return token('tabs.tab.height', '4.4rem');
    },
    background: function background(_ref3) {
      var token = _ref3.token;
      return token('tabs.tab.background.color', token('color.container.interactive.idle'));
    }
  }, text.styles({
    target: 'tabs.tab',
    fallback: 'normal.default',
    color: function color(_ref4) {
      var token = _ref4.token;
      return token('color.textStyle.body.subtext');
    }
  })), border.styles({
    target: 'tabs.tab',
    bottom: {
      width: 'thin',
      color: function color() {
        return 'transparent';
      }
    }
  })), padding.styles({
    target: 'tabs.tab',
    x: 'm',
    y: 's'
  })), margin.styles({
    target: 'tabs.tab',
    x: 0,
    y: 0
  })), {}, {
    '&:hover': _objectSpread(_objectSpread({}, text.styles({
      target: 'tabs.tab.hover',
      fallback: 'normal.semibold',
      color: 'body.default'
    })), border.styles({
      target: 'tabs.tab.hover'
    })),
    '&:focus': _objectSpread({
      outline: 'none',
      boxShadow: 'none'
    }, text.styles({
      target: 'tabs.tab.hover',
      fallback: 'normal.semibold'
    }))
  }),
  containerActive: _objectSpread(_objectSpread(_objectSpread({}, text.styles({
    target: 'tabs.tab.active',
    fallback: 'normal.semibold',
    color: 'body.default'
  })), border.styles({
    target: 'tabs.tab.active'
  })), {}, {
    background: function background(_ref5) {
      var token = _ref5.token;
      return token('tabs.tab.active.background.color');
    },
    '&:hover': _objectSpread(_objectSpread({}, text.styles({
      target: 'tabs.tab.active',
      fallback: 'normal.semibold',
      color: 'body.default'
    })), border.styles({
      target: 'tabs.tab.active.hover'
    }))
  }),
  containerDisabled: {
    color: 'lightgrey',
    cursor: 'default',
    '&:hover': {
      color: 'lightgrey'
    }
  },
  label: {
    display: 'flex',
    '& svg': {
      height: '1.6rem',
      width: 'auto'
    }
  },
  icon: _objectSpread({
    display: 'flex',
    alignItems: 'center'
  }, margin.styles({
    target: 'tabs.tab.icon',
    left: 'xs'
  }))
});

function Tab(_ref6) {
  var _isActive$toString2;

  var s = _ref6.styles,
      name = _ref6.name,
      label = _ref6.label,
      isDisabled = _ref6.isDisabled,
      isActive = _ref6.isActive,
      items = _ref6.items,
      Icon = _ref6.Icon,
      onClick = _ref6.onClick;

  function handleClick() {
    if (!isDisabled) {
      onClick === null || onClick === void 0 ? void 0 : onClick({
        name: name,
        label: label
      });
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter' || e.key === '') {
      e.target.click();
    }
  }

  if (items) {
    return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ActionMenu, {
      items: items // eslint-disable-next-line
      ,
      Button: /*#__PURE__*/forwardRef(function (props, ref) {
        var _isActive$toString;

        return /*#__PURE__*/React.createElement("a", _extends({
          ref: ref,
          role: "tab",
          "data-tab-name": name,
          "aria-selected": isActive === null || isActive === void 0 ? void 0 : (_isActive$toString = isActive.toString) === null || _isActive$toString === void 0 ? void 0 : _isActive$toString.call(isActive),
          tabIndex: 0,
          onClick: handleClick,
          onKeyDown: handleKeyDown
        }, s('container', {
          containerActive: isActive,
          containerDisabled: isDisabled
        }), props), /*#__PURE__*/React.createElement("span", s('label'), label), Icon && /*#__PURE__*/React.createElement("span", s('icon'), /*#__PURE__*/React.createElement(Icon, null)));
      })
    }));
  }

  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", _extends({
    role: "tab",
    "data-tab-name": name,
    "aria-selected": isActive === null || isActive === void 0 ? void 0 : (_isActive$toString2 = isActive.toString) === null || _isActive$toString2 === void 0 ? void 0 : _isActive$toString2.call(isActive),
    tabIndex: 0,
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, s('container', {
    containerActive: isActive,
    containerDisabled: isDisabled
  })), /*#__PURE__*/React.createElement("span", s('label'), label), Icon && /*#__PURE__*/React.createElement("span", s('icon'), /*#__PURE__*/React.createElement(Icon, null))));
}

export default styled(defaultStyles)(Tab);